import { Component, OnInit } from '@angular/core';
import { MasterService ,FrontOffService} from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-admitcard',
  templateUrl: './admitcard.component.html',
  styleUrls: ['./admitcard.component.scss'],
  providers:[MasterService,FrontOffService]
})
export class AdmitcardComponent implements OnInit {

  memberdetails:any[]=[];
  classdetails:any[]=[];
  arrashead:any=[];
  arrastype:any=[];
  closeResult: string;
  classes: any=[];
  section: any=[];
  arrcourse:any=[];
  arrsubcomb:any=[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  objass:any={};
  objastype:any={};
  objfilt:any={};
  arreval:any=[];
  arrstudent:any=[];
  arrformat:any=[{value:'1',name:'Format-1'},{value:'2',name:'Format-2'},{value:'3',name:'Format-3'}];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  constructor(private http: HttpClient, private mservice: MasterService,private aservice: FrontOffService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.objfilt.frmtype="1";

    this.masasshead();
    this.masasstype();
    this.masclass();
    this.getcourses();
    this.Getsubcomb();
  }


  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.objfilt.clid=resultArray[0].clid;
            this.getcourses();
        },
        error => console.log("Error :: " + error)
        )
  }

  getstudentsdata() {
    this.aservice.getstudentslist(this.objfilt.clid,this.objfilt.scid,this.objfilt.crid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrstudent = resultArray;
          // this.fmodel.stuid= resultArray[0].stuid;
           // this.SelectReportDetails();
        },
        error => console.log("Error :: " + error)
        )
  }


  exportcolrpt(stuid)
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
  var format=this.objfilt.frmtype;
   var url=this.aservice.callurl+"fpdf181/pdfreports/admticket"+format+".php?clcd="+clcd+"&aycd="+aycd+"&clid="+this.objfilt.clid+"&scid="+this.objfilt.scid+"&crid="+this.objfilt.crid+"&asid="+this.objfilt.asid+"&astpid="+this.objfilt.astpid+"&stuid="+stuid;
   console.log("url",url)
   window.open(url,'');

}
  private getcourses() {

    this.mservice.getcourse()
  .subscribe((result:any) => {
  
  this.arrcourse=result;
  this.objfilt.crid=result[0].crid;
  this.massection();
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  Getsubcomb()
  {
    debugger
    this.mservice.sel_sp_exmsubcomb()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.objfilt.sucbid=resultArray[0].sucbid;
      //this.clsdate=resultArray;
      this.arrsubcomb = resultArray;
     // this.getevpattern();
      },
     error => console.log("Error :: " + error)
  )
  }
   

  evalfilters()
  {
    this.masclass();
    this.getcourses();
    this.Getsubcomb();
  }
  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.section = resultArray;
            this.objfilt.scid=resultArray[0].scid;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrashead = resultArray;
            this.objfilt.asid=resultArray[0].asid;
           // this.fmodel.assid=resultArray[0].asid;
           this.masasstype();
        },
        error => console.log("Error :: " + error)
        )
  }
  masasstype() {
    this.mservice.sel_sp_masasstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrastype = resultArray;
            this.objfilt.astpid=resultArray[0].astpid;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }



  



}
